export default class EventChannel extends EventTarget {
  on = (event, fn) => {
    this.addEventListener(event, fn);
  };
  emit = (event, data) => {
    this.dispatchEvent(new CustomEvent(event, {detail: data}));
  };
}
